import clsx from 'clsx';

import type {KeyedArray} from '@/modules/foundation/shared/types';
import type {ContentBlockContainerProps} from '@/modules/page/components/content-blocks/block-container';
import {ContentBlockContainer} from '@/modules/page/components/content-blocks/block-container';

export type Fact = {
	title: string;
	description?: string;
};

interface Props extends ContentBlockContainerProps {
	facts: KeyedArray<Fact>;
	insideToc?: boolean;
}

export const FactsList = ({facts, options, insideToc}: Props) => {
	return (
		<ContentBlockContainer options={options} insideToc={insideToc}>
			<div className="@container">
				<ul className={clsx('grid', 'gap-10', 'items-start', '@3xl:grid-cols-3')}>
					{facts.map((fact, idx) => (
						<li key={`${fact.title}-${idx}`} className={clsx('grid')}>
							<strong
								className={clsx(
									'font-display',
									'text-[17px]',
									'leading-tight',
									'mb-1',
									'font-medium',
								)}
							>
								{fact.title}
							</strong>
							{fact.description && (
								<span className={clsx('text-sm')}>{fact.description}</span>
							)}
						</li>
					))}
				</ul>
			</div>
		</ContentBlockContainer>
	);
};
